<template>
    <div>
        <timeline :time-line-items="steps" :active-index="0">
            <template v-slot:form>
                <div class="form-group row">
                    <div class="col-12">
                        <label class="text-muted" for="companyForm.name">{{ __('account-setup.company.name') }}</label>
                        <input v-model="form.name" type="text"
                               class="form-control" id="companyForm.name"
                               required>
                        <span v-if="form.errors.name"
                              class="invalid-feedback d-inline">{{ form.errors.name }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <label class="text-muted" for="companyForm.street1">{{ __('store.street_and_building_number') }}</label>
                        <input v-model="form.street1" type="text" class="form-control"
                               id="companyForm.street1" required>
                        <span v-if="form.errors.street1"
                              class="invalid-feedback d-inline">{{ form.errors.street1 }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <label class="text-muted" for="companyForm.street2">{{ __('store.street2') }}<span
                            class="text-muted"> (optional)</span></label>
                        <input v-model="form.street2" type="text" class="form-control"
                               id="companyForm.street2">
                        <span v-if="form.errors.street2"
                              class="invalid-feedback d-inline">{{ form.errors.street2 }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-6">
                        <label class="text-muted" for="companyForm.postcode">{{ __('store.postcode') }}</label>
                        <input v-model="form.postcode" type="text" class="form-control"
                               id="companyForm.postcode" required>
                        <span v-if="form.errors.postcode"
                              class="invalid-feedback d-inline">{{ form.errors.postcode }}</span>
                    </div>
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.city">{{ __('general.city') }}</label>
                        <input v-model="form.city" type="text" class="form-control" id="companyForm.city"
                               required>
                        <span v-if="form.errors.city"
                              class="invalid-feedback d-inline">{{ form.errors.city }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.country">{{ __('general.country') }}</label>
                        <select v-model="form.country" class="form-control" id="companyForm.country"
                                required>
                            <option v-for="country in countries" :value="country">{{
                                    __('countries.with_flag.' + country)
                                }}
                            </option>
                        </select>
                        <span v-if="form.errors.country"
                              class="invalid-feedback d-inline">{{ form.errors.country }}</span>
                    </div>
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.state">{{ __('store.state') }}</label>
                        <input v-model="form.state" type="text" class="form-control" id="companyForm.state"
                               :required="form.country === 'us'">
                        <span v-if="form.errors.state"
                              class="invalid-feedback d-inline">{{ form.errors.state }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.email">{{ __('general.email') }}</label>
                        <input v-model="form.email" type="email" class="form-control"
                               id="companyForm.email" required>
                        <span v-if="form.errors.email"
                              class="invalid-feedback d-inline">{{ form.errors.email }}</span>
                    </div>
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.website">{{ __('general.website') }}<span
                            class="text-muted"> (optional)</span></label>
                        <input class="form-control" id="companyForm.website">
                        <span v-if="form.errors.website"
                              class="invalid-feedback d-inline">{{ form.errors.website }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.phone">{{ __('user.phone') }}<span
                            class="text-muted"> (optional)</span></label>
                        <input v-model="form.phone" type="text" class="form-control"
                               id="companyForm.phone">
                        <span v-if="form.errors.phone"
                              class="invalid-feedback d-inline">{{ form.errors.phone }}</span>
                    </div>
                    <div class="col-lg-6">
                        <label class="text-muted" for="companyForm.ust_id">{{ __('sale.delivery_note_info.ustId') }}
                            <span v-show="form.country === 'us'" class="text-muted"> (optional)</span>
                        </label>
                        <input v-model="form.ust_id" type="text" class="form-control" id="companyForm.ust_id"
                               :required="form.country !== 'us'">
                        <span v-if="form.errors.ust_id"
                              class="invalid-feedback d-inline">{{ form.errors.ust_id }}</span>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-20">
                    <button @click="previousStep" class="mr-auto py-4 btn btn-secondary">
                        <i class="fas fa-arrow-circle-left mr-3"></i>{{ __('actions.back') }}
                    </button>
                    <button @click="submit()" class="btn btn-primary">
                        {{ __('actions.next') }}<i class="fas fa-arrow-circle-right ml-3"></i>
                    </button>
                </div>

            </template>
        </timeline>
    </div>
</template>

<script>
import Timeline from '@components/Timeline';
import SelectCountryFlag from '@components/SelectCountryFlag';
import AccountSetupLayout from '@layouts/AccountSetupLayout';

export default {
    name: 'CompanyDetails',
    components: {SelectCountryFlag, Timeline},
    layout: AccountSetupLayout,
    props: {
        company: Object | null,
        steps: Object,
    },
    remember: {
        data: ['form'],
        key: 'Company',
    },
    data() {
        return {
            form: this.$inertia.form({
                id: null,
                name: null,
                email: null,
                website: null,
                phone: null,
                ust_id: null,
                city: null,
                street1: null,
                street2: null,
                postcode: null,
                country: null,
                state: null,
            }),
            countries: [
                'de',
                'at',
                'fr',
                'us',
            ],
        };
    },
    mounted() {
        if (this.company) {
            Object.assign(this.form, this.company);
        }
    },
    methods: {
        previousStep() {
            this.$inertia.get(this.$route('account-setup.show'));
        },

        submit() {
            this.form.post(this.$route('account-setup-company.update'), {
                preserveState: true,
                preserveScroll: true,
                onError: () => {
                    toastr.error(__('general.error_check_data'))
                },
                onSuccess:() => {
                    toastr.success(__('account-setup.thing.success_single', {thing: __('account-setup.company.data')}))
                }
            });
        },
    },
};
</script>
